import { useInfiniteQuery } from '@tanstack/react-query'
import { connect } from 'getstream';
import { streamApi, supabase } from '../../api'

const getPosts = async (ranking?: string, limit?: number) => {
  const { data: userData } = await supabase.auth.getSession();
  const userId = userData.session?.user.id;
  // client
  const REACT_APP_STREAM_API_KEY: string = process.env.REACT_APP_STREAM_API_KEY || '';
  const REACT_APP_STREAM_APP_ID: string = process.env.REACT_APP_STREAM_APP_ID || '';

  const result = await streamApi.post('/getToken', {
    id: userId || 'anonymous',
  });

  const client: any = connect(
    REACT_APP_STREAM_API_KEY,
    result.token,
    REACT_APP_STREAM_APP_ID,
  );
  // client

  const feedData = await client.feed('user', userId).get({
    limit,
    ranking: ranking || undefined,
    enrich: true,
    reactions: {
      own: true,
      counts: true,
      recent: false,
    },
  });

  // return feedData
  const ids = feedData.results.map((v: any) => v.foreign_id).filter((v) => v)
  const { data, error } = await supabase
    .from('posts')
    .select(`
      *,
      category:categories(*),
      profile:user_profiles (id, username),
      assetPrices:posts_assets (price_time_posting, asset_id),
      assets:assets!posts_assets (
        *,
        category:categories(*)
      )`)
    .in('id', ids);

  if (error) {
    throw new Error(error.message)
  }
  feedData.results = feedData.results.map((v: any) => {
    const d = data.find((item: any) => (`${item.id}` === v.foreign_id))
    return {
      ...v,
      data: d ? {
        ...d,
        assets: (d?.assets || []).map((a) => ({
          ...a,
          postingPrice: d?.assetPrices
            .find((ap) => (ap.asset_id === a.id))?.price_time_posting || 0,
        })),
      } : d,
    }
  }).filter((v: any) => v.data)

  return feedData
}

export default function useOwnFeedPosts(ranking: string = '', limit: number = 5) {
  const queryKey = ['useOwnFeedPosts', ranking, limit]
  return useInfiniteQuery({
    queryKey,
    queryFn: () => getPosts(
      ranking,
      limit,
    ),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    getPreviousPageParam: () => undefined,
    getNextPageParam: (lastPage: any) => (
      lastPage.next
        ? lastPage.results[lastPage.results.length - 1]?.id
        : undefined
    ),
  })
}
